import { TooltipHost } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { CoveragesFilter } from "types/types";
import { TlpSelect } from "./TlpSelect";

type Props = {
  value: CoveragesFilter;
  onChange: (val: CoveragesFilter) => void;
};

export const CoveragesFilterSelect = ({ value, onChange }: Props) => {
  const { t } = useTranslation();

  const options = [
    {
      text: t("bfm.coveragesFilter.all"),
      key: CoveragesFilter.all,
    },
    {
      text: t("bfm.coveragesFilter.with_coverages"),
      key: CoveragesFilter.withCoverages,
    },
    {
      text: t("bfm.coveragesFilter.without_coverages"),
      key: CoveragesFilter.withoutCoverages,
    },
  ];

  // "All" alone is ambiguous next to the other filters, so the tooltip names the filter
  return (
    <TooltipHost content={t("bfm.coveragesFilter.label")}>
      <TlpSelect
        value={options.find((option) => option.key === value)}
        onChange={(o: any) => {
          onChange(o.key);
        }}
        options={options}
        isClearable={false}
        isLoading={false}
      />
    </TooltipHost>
  );
};
